import { Component, inject, signal } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AuthService } from '../../services/auth.service';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ButtonDirective } from 'primeng/button';
import { InputText } from 'primeng/inputtext';

@Component({
  selector: 'app-login-dialog',
  imports: [ButtonDirective, InputText, ReactiveFormsModule],
  templateUrl: './login-dialog.component.html',
  styleUrl: './login-dialog.component.scss',
})
export class LoginDialogComponent {
  private auth = inject(AuthService);
  public ref = inject(DynamicDialogRef);
  private cfg = inject(DynamicDialogConfig);
  private initialEmail = (this.cfg?.data?.email as string | undefined) ?? '';
  public loading = signal(false);
  public error = signal<string | null>(null);

  public form = new FormGroup({
    email: new FormControl<string>(this.initialEmail, {
      nonNullable: true,
      validators: [Validators.required, Validators.email],
    }),
    password: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required],
    }),
  });

  public onSubmit() {
    if (this.form.invalid || this.loading()) return;
    this.loading.set(true);
    this.error.set(null);

    const { email, password } = this.form.getRawValue();
    this.auth.login(email, password).subscribe({
      next: () => {
        this.loading.set(false);
        this.ref.close('success');
      },
      error: (err) => {
        this.loading.set(false);
        this.error.set(err?.error?.message || 'Nie udało się zalogować.');
      },
    });
  }

  openRegisterDialog() {
    const { email } = this.form.getRawValue();
    this.loading.set(false);
    this.ref.close('register:' + email);
  }
}
